import {
  cloneObject,
  deserify,
  getLocalStorage,
  IStyles,
  Loader,
  ModeOfConductionStringType,
  NoContentCard,
  PrimaryButton,
  pxToRem,
  pxTovW,
  StepperComponent,
  theme,
  useAndroidAppRefreshGate,
  useCommonServiceClientContext,
} from '@geneo2-web/shared-ui';
import {
  Box,
  Checkbox,
  Divider,
  Typography,
  useMediaQuery,
} from '@mui/material';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { ChapterSelection } from './components/ChapterSelection';
import { Settings } from './components/Settings';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { useEffect, useState } from 'react';
import { ChapterTopicPopup } from '../../../../components/ChapterTopicPopup';
import {
  CourseIndexInfo,
  SubjectChapterMiniInfo,
} from '@protos/content_management/content.common.apis_pb';
import {
  useAppDispatch,
  useAppSelector,
} from '../../../../reduxStore/reduxHooks';
import {
  IFAASSESSMENTCONFIG,
  resetAssessmentFlowState,
  resetCreatedAssessmentStatus,
  resetCustomHomework,
  resetDraftUploadedFiles,
  resetFetchedAssessmentDetails,
  resetSelectedTasksInfo,
  setAssessmentCreationType,
  setCourseIndexInfo,
  setFAAssessmentConfig,
  setFAEditStep,
  setFAQuestionModuleMap,
  setFASelectedChapterData,
  setModuleFilteredQuestions,
  setQuestionsCount,
  setSelectedTasksInfo,
} from '../../reducer/assessmentFlow.slice';
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from 'react-router-dom';
import {
  ASSESSMENT_CURRENT,
  FORMATIVE,
  HOME,
  HOMEWORK_MANAGE,
} from '../../../../routeHandling/RoutesNomenclature';
import { ProfileRolesEnum } from '@protos/user_management/ums.db_pb';
import { setToastInfo } from '../../../Auth/reducer/auth.slice';
import { DifficultyLevelEnum } from '@protos/content_management/content.db_pb';
import {
  createTaskInfoModel,
  getDifficultyLevelFromString,
} from '../../Common/ReviewAssessment/functions';
import { getMiddleApproximateTime } from '../../utils/assessment.utils';
import { AssessmentCreationEnum } from '@protos/learning_management/lms.assessment.teacher.apis_pb';
import { EditWarningPopup } from '../../../../components/EditWarningPopup';
import { useGlobalContext } from '../../../../app/Context/GlobalContextProvider';
import { FAChapterSelectionCard } from './components/FAChapterSelectionCard';
import {
  getModeOfConductionEnum,
  getModeOfConductionString,
} from '../../../../utils/functions';
import { MarkingSchemeEnum } from '@protos/learning_management/lms.db_pb';
import { interactionEvent } from '../../../Auth/auth.events';
import { useDownloadContext } from '../../../../app/Context/DownloadContextProviderV2';

const styles: IStyles = {
  root: {
    boxSizing: 'border-box',
    paddingX: { xs: pxToRem(20), md: pxTovW(50), lg: pxTovW(240) },
    display: 'flex',
    flexDirection: 'column',
    // height: { md: '100vh' },
    alignItems: 'center',
    paddingBottom: { xs: pxToRem(80), md: pxTovW(40) },
    maxHeight: {
      xs: `calc(100vh - ${pxToRem(60)})`,
      md: `none`,
    },
    overflow: { xs: 'auto' },
  },
  buttonContainer: {
    position: { xs: 'fixed', md: 'unset' },
    top: { xs: '91%' },
    width: { xs: '90%', md: pxTovW(397) },
    height: { xs: pxToRem(50), md: pxTovW(80), lg: pxTovW(60) },
    marginLeft: 'auto',
    zIndex: { xs: 1, md: 0 },
  },
};

export const ForamtiveAssessmentCreate = () => {
  console.log('Formattive assessment');
  const [openAddChapterPopup, setOpenAddChapterPopup] = useState(false);
  const [loading, setLoading] = useState<'loading' | 'completed' | 'error'>(
    'completed'
  );

  const { subject_id } = useParams();
  const { isIpadOnly } = useGlobalContext();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const location = useLocation();
  const pathSegments = location.pathname.split('/');
  const { isOffline } = useDownloadContext();
  const [editPopupOpen, setEditPopupOpen] = useState(false);
  const [logoClick, setLogoClick] = useState(false);
  const navigate = useNavigate();
  const { setSelectedFunction, setSelectedLogoClickHandler } =
    useGlobalContext();
  const dispatch = useAppDispatch();
  const teacher_id = getLocalStorage('userId');

  const {
    ContentCommonAPIServiceV1ClientWithStatusCodeHandler,
    LmsAssessmentTeacherAPIServiceV8WithStatusCodeHandler,
  } = useCommonServiceClientContext();

  const {
    fa_selected_chapter_data,
    fa_assessment_config,
    chapter_topic_data,
    fa_edit_step,
    assesment_creation_type,
    fa_format_details,
  } = deserify(useAppSelector((state) => state.assessment));
  const [step, setStep] = useState<'chapterSelection' | 'settings' | undefined>(
    fa_edit_step
      ? fa_edit_step
      : fa_selected_chapter_data
      ? 'chapterSelection'
      : undefined
  );
  const [modeOfConductionValue, setModeOfConductionValue] =
    useState<ModeOfConductionStringType>(
      getModeOfConductionString(assesment_creation_type.modeOfConduction) ||
        'Geneo App'
    );

  const [assessmentConfig, setAssessmentConfig] = useState<IFAASSESSMENTCONFIG>(
    {
      QuestionTypes: fa_assessment_config?.QuestionTypes || [],
      noOfQuestions: fa_assessment_config?.noOfQuestions || 0,
      overallDifficultyLevel:
        fa_assessment_config?.overallDifficultyLevel || 'Medium',
      bloomLevels: fa_assessment_config?.bloomLevels || [],
      // approximateTime: fa_assessment_config?.approximateTime || 0,
    }
  );
  const [selectedChapterList, setSelectedChapterList] = useState<
    SubjectChapterMiniInfo[]
  >([...(fa_selected_chapter_data?.chapters || [])]);
  const backButtonClick = async () => {
    setEditPopupOpen(true);
  };
  const handleLogoClick = () => {
    setLogoClick(true);
    setEditPopupOpen(true);
  };
  // const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const home = searchParams.get('home');
  useEffect(() => {
    dispatch(resetSelectedTasksInfo());
    dispatch(resetCreatedAssessmentStatus());
    dispatch(resetFetchedAssessmentDetails());
    dispatch(resetCustomHomework());
    dispatch(resetDraftUploadedFiles());
    setSelectedFunction(() => backButtonClick);
    setSelectedLogoClickHandler(() => handleLogoClick);
    return () => {
      setSelectedFunction(() => null);
      setSelectedLogoClickHandler(() => null);
    };
  }, []);

  // On mobile this page's root scrolls inside its own bounded container
  // (maxHeight: calc(100vh - 60px) + overflow: 'auto' above), not via the
  // document body — so the native Android WebView wrapper's scrollY-based
  // pull-to-refresh guard never sees it move off 0, no matter how far the
  // user scrolls. Disable native app refresh for the whole lifetime of
  // this flow instead, same as ReviewAssessment/SearchQuestions.
  useAndroidAppRefreshGate();

  const fetchTotalChapterTopicData = async () => {
    if (!teacher_id) {
      return;
    }
    try {
      setLoading('loading');
      const chapterTopicData =
        await ContentCommonAPIServiceV1ClientWithStatusCodeHandler.fetchCourseIndexInfo(
          {
            personId: BigInt(teacher_id),

            personType: ProfileRolesEnum.PROFILE_ROLE_TEACHER,
            subjectId: Number(subject_id),
          }
        );
      if (chapterTopicData) {
        dispatch(setCourseIndexInfo(chapterTopicData?.data));
      }
    } catch (error) {
      dispatch(
        setToastInfo({
          label: 'Error fetching Chapter Topic Data',
          variant: 'error',
          open: true,
        })
      );
      setLoading('error');
    } finally {
      setLoading('completed');
    }
  };
  const getModuleQuestions = async () => {
    const moduleIds = fa_selected_chapter_data?.chapters.flatMap((chapter) => [
      chapter.chapterId,
      ...chapter.topics.map((topic) => topic.topicId),
    ]);
    if (!moduleIds || moduleIds.length === 0) {
      return;
    }
    try {
      setLoading('loading');
      const response =
        await LmsAssessmentTeacherAPIServiceV8WithStatusCodeHandler.getModuleQuestionsWithFilters(
          {
            teacherId: teacher_id,
            noOfQuestions: assessmentConfig?.noOfQuestions,
            modeOfConduction: assesment_creation_type?.modeOfConduction,
            assessmentCreationType:
              AssessmentCreationEnum.ASSESSMENT_CREATION_FORMATIVE,
            approximateTime: getMiddleApproximateTime({
              difficulty: assessmentConfig?.overallDifficultyLevel,
              questionCount: assessmentConfig?.noOfQuestions,
            }),
            avgDifficultyLevel: getDifficultyLevelFromString(
              assessmentConfig?.overallDifficultyLevel || 'Medium'
            ),
            subjectId: Number(subject_id),
            sectionId: fa_format_details?.selectedSection?.id,
            moduleIds: moduleIds,
            bloomLevels: assessmentConfig.bloomLevels || [],
            requiredQuestionTypes: assessmentConfig.QuestionTypes || [],
          }
        );
      if (response.data) {
        const order = {
          [DifficultyLevelEnum.DIFFICULTY_LEVEL_LOW]: 0,
          [DifficultyLevelEnum.DIFFICULTY_LEVEL_MEDIUM]: 1,
          [DifficultyLevelEnum.DIFFICULTY_LEVEL_HIGH]: 2,
          [DifficultyLevelEnum.DIFFICULTY_LEVEL_UNDEFINED]: 3,
        };
        const questionsCreated = cloneObject(response.data.questions).sort(
          (a, b) =>
            order[
              a.questionMeta?.difficultyLevel ||
                DifficultyLevelEnum.DIFFICULTY_LEVEL_UNDEFINED
            ] -
            order[
              b.questionMeta?.difficultyLevel ||
                DifficultyLevelEnum.DIFFICULTY_LEVEL_UNDEFINED
            ]
        );
        dispatch(
          setModuleFilteredQuestions({
            ...response.data,
            questions: questionsCreated,
          })
        );
        dispatch(setFAQuestionModuleMap(response.data.questionModuleMap || []));

        const tasksInfo = createTaskInfoModel(
          questionsCreated,
          assesment_creation_type.markingScheme,
          assesment_creation_type.marksPerQuestion
        );
        dispatch(setSelectedTasksInfo(tasksInfo));
        dispatch(setQuestionsCount());
        if (home) {
          navigate(`${FORMATIVE}${ASSESSMENT_CURRENT}?home=true`);
        } else {
          navigate(`${FORMATIVE}${ASSESSMENT_CURRENT}`);
        }
      } else {
        dispatch(
          setToastInfo({
            label: 'No questions found for the selected chapters',
            variant: 'info',
            open: true,
          })
        );
      }
    } catch (err) {
      console.log(err);
      setLoading('error');
      dispatch(
        setToastInfo({
          label: 'Error fetching module questions',
          variant: 'error',
          open: true,
        })
      );
    } finally {
      setLoading('completed');
    }
  };
  useEffect(() => {
    if (step === 'chapterSelection' || step === undefined) {
      fetchTotalChapterTopicData();
    }
  }, []);
  const addChapterHandler = async (chapter: SubjectChapterMiniInfo) => {
    const updatedChapters: SubjectChapterMiniInfo[] = [
      ...selectedChapterList,
      chapter,
    ];

    setSelectedChapterList([...updatedChapters]);
    await interactionEvent({
      url: 'Teacher_formative_assessment_create',
      context: 'Add_chapter',
      name: 'ADD',
      pathSegments: pathSegments,
      isOffline: isOffline,
    });
  };
  const deleteChapterHandler = async (chapterInfo: SubjectChapterMiniInfo) => {
    if (!selectedChapterList) return;

    const updatedChapters: SubjectChapterMiniInfo[] = (
      selectedChapterList || []
    ).filter((ch) => ch.chapterId !== chapterInfo.chapterId);

    setSelectedChapterList([...updatedChapters]);
    await interactionEvent({
      url: 'Teacher_formative_assessment_create',
      context: 'Your_added_chapter',
      name: 'DELETE',
      pathSegments: pathSegments,
      isOffline: isOffline,
    });
  };

  const chapterEditHandler = async (chapter: SubjectChapterMiniInfo) => {
    const updatedChapters: SubjectChapterMiniInfo[] = (
      selectedChapterList || []
    ).map((ch) => (ch.chapterId === chapter.chapterId ? chapter : ch));

    setSelectedChapterList([...updatedChapters]);
    await interactionEvent({
      url: 'Teacher_formative_assessment_create',
      context: 'Your_added_chapter',
      name: 'EDIT',
      pathSegments: pathSegments,
      isOffline: isOffline,
    });
  };

  const modeOfConductionChangeHandler = async (
    modeOfConduction: ModeOfConductionStringType
  ) => {
    setModeOfConductionValue(modeOfConduction);
    dispatch(
      setAssessmentCreationType({
        ...assesment_creation_type,
        modeOfConduction: getModeOfConductionEnum(modeOfConduction),
        markingScheme:
          modeOfConduction === 'Geneo Clicker' ||
          modeOfConduction === 'Geneo Live Quiz'
            ? MarkingSchemeEnum.MARKING_SCHEME_GENEO
            : assesment_creation_type.markingScheme ===
              MarkingSchemeEnum.MARKING_SCHEME_JEE
            ? MarkingSchemeEnum.MARKING_SCHEME_JEE
            : assesment_creation_type.markingScheme ===
              MarkingSchemeEnum.MARKING_SCHEME_CUSTOM
            ? MarkingSchemeEnum.MARKING_SCHEME_CUSTOM
            : MarkingSchemeEnum.MARKING_SCHEME_GENEO,
      })
    );

    await interactionEvent({
      url: 'Teacher_formative_assessment_create',
      context: 'Navigation_bar',
      name: modeOfConduction.toUpperCase().replace(/\s+/g, '_'),
      pathSegments: pathSegments,
      isOffline: isOffline,
    });
  };
  return loading === 'loading' ? (
    <Loader />
  ) : (
    <Box sx={styles.root}>
      <Box
        sx={{
          width: '100%',
          justifyContent: 'space-between',
          // alignItems: 'center',
          marginY: { xs: pxToRem(23), md: pxTovW(41) },
          display: 'flex',
        }}
      >
        <Typography variant="h1">Formative Assessment</Typography>
        {step === 'chapterSelection' ? (
          <PrimaryButton
            sx={styles.buttonContainer}
            onClick={async () => {
              setStep('settings');
              await interactionEvent({
                url: 'Teacher_formative_assessment_create',
                context: 'Navigation_bar',
                name: 'NEXT',
                pathSegments: pathSegments,
                isOffline: isOffline,
              });
            }}
            disabled={
              !fa_selected_chapter_data ||
              fa_selected_chapter_data.chapters.length === 0
            }
          >
            <Typography
              variant={isMobile ? 'h2' : 'h3'}
              color={'common.white'}
              fontWeight={'bold'}
            >
              NEXT
            </Typography>
          </PrimaryButton>
        ) : step === 'settings' ? (
          <PrimaryButton
            sx={styles.buttonContainer}
            disabled={
              assessmentConfig.noOfQuestions === 0 ||
              (assessmentConfig.QuestionTypes?.length ?? 0) === 0
            }
            onClick={async () => {
              dispatch(setFAAssessmentConfig(assessmentConfig));
              getModuleQuestions();
              await interactionEvent({
                url: 'Teacher_formative_assessment_create',
                context: 'Formative_assessment',
                name: 'CREATE_TEST',
                pathSegments: pathSegments,
                isOffline: isOffline,
              });
            }}
          >
            <Typography
              variant={isMobile ? 'h2' : 'h3'}
              color={'common.white'}
              fontWeight={'bold'}
            >
              CREATE TEST
            </Typography>
          </PrimaryButton>
        ) : (
          <></>
        )}
      </Box>
      <Box sx={{ width: { xs: pxToRem(166), md: pxTovW(299) } }}>
        <StepperComponent
          step={step}
          // setStep={async (step) => {
          //   if (step === 'settings') {
          //     await getModuleQuestionStats();
          //     setStep(step);
          //   } else {
          //     setStep(step);
          //   }
          // }}
          step1ClickHandler={() => {
            setStep('chapterSelection');
            dispatch(setFAAssessmentConfig(undefined));
          }}
          step2ClickHandler={() => {
            setStep('settings');
          }}
          disableStep2={
            !fa_selected_chapter_data ||
            fa_selected_chapter_data.chapters.length === 0
          }
          disableStep1={
            !fa_selected_chapter_data ||
            fa_selected_chapter_data.chapters.length === 0
          }
        />
      </Box>
      {step === undefined ||
      !fa_selected_chapter_data ||
      fa_selected_chapter_data.chapters.length === 0 ? (
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            gap: pxTovW(20),
          }}
        >
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
              marginY: { xs: pxToRem(23), md: pxTovW(41) },
            }}
          >
            <Typography variant="h2">
              <span style={{ color: '#007CDC' }}>Step 1: </span> Add Chapters
              and Topics first to create the assessment
            </Typography>
          </Box>
          {chapter_topic_data?.chapters?.length ? (
            <PrimaryButton
              sx={{
                width: { xs: pxToRem(211), md: pxTovW(397) },
                height: { xs: pxToRem(48), md: pxTovW(77) },
                gap: { xs: pxToRem(10), md: pxTovW(10) },
              }}
              onClick={async () => {
                setOpenAddChapterPopup(true);
                await interactionEvent({
                  url: 'Teacher_formative_assessment_create',
                  context: 'Formative_assessment',
                  name: 'ADD_CHAPTER',
                  pathSegments: pathSegments,
                  isOffline: isOffline,
                });
              }}
            >
              <AddCircleIcon
                sx={{
                  color: '#03612D',
                  fontSize: { xs: pxToRem(24), md: pxTovW(41) },
                }}
              />
              <Typography
                variant="h2"
                fontWeight="bold"
                color="white"
                sx={{
                  fontSize: { xs: pxToRem(18), md: pxTovW(30), lg: pxTovW(24) },
                }}
              >
                Add Chapter
              </Typography>
            </PrimaryButton>
          ) : (
            <NoContentCard
              variant="info"
              icon="cards"
              text="No Chapters Available"
              rootStyle={{ mt: { xs: pxToRem(20), md: pxTovW(50) } }}
            />
          )}
        </Box>
      ) : step === 'chapterSelection' ? (
        <ChapterSelection
          selectedChapterList={fa_selected_chapter_data.chapters}
          setSelectedChapterList={setSelectedChapterList}
          addMoreHandler={async () => {
            setOpenAddChapterPopup(true);
            await interactionEvent({
              url: 'Teacher_formative_assessment_create',
              context: 'Your_added_chapters',
              name: 'ADD_MORE',
              pathSegments: pathSegments,
              isOffline: isOffline,
            });
          }}
          chapterEditHandler={(chapter: SubjectChapterMiniInfo) => {
            const updatedChapters: SubjectChapterMiniInfo[] = (
              fa_selected_chapter_data?.chapters || []
            ).map((ch) => (ch.chapterId === chapter.chapterId ? chapter : ch));
            setSelectedChapterList([...updatedChapters]);
            dispatch(
              setFASelectedChapterData({
                ...fa_selected_chapter_data,
                chapters: updatedChapters,
              })
            );
          }}
          setStep={setStep}
        />
      ) : (
        <Settings
          assessmentConfig={assessmentConfig}
          setAssessmentConfig={setAssessmentConfig}
          modeOfConduction={modeOfConductionValue}
          onChangeModeOfConduction={modeOfConductionChangeHandler}
        />
      )}
      {
        <ChapterTopicPopup
          open={openAddChapterPopup}
          handleClose={() => {
            if (step === undefined && fa_selected_chapter_data?.chapters) {
              setStep('chapterSelection');
            }
            setSelectedChapterList(fa_selected_chapter_data?.chapters || []);
            setOpenAddChapterPopup(false);
          }}
          popupBody={
            <ChapterListComponent
              selectedChapterList={selectedChapterList}
              onSelectAllChapters={(chapters) =>
                setSelectedChapterList([...chapters])
              }
              addHandler={addChapterHandler}
              deleteHandler={deleteChapterHandler}
              chapterEditHandler={chapterEditHandler}
              confirmHandler={async () => {
                // dispatch(setFASelectedChapterData(ChapterList));
                if (selectedChapterList.length === 0) {
                  setStep(undefined);
                  dispatch(setFASelectedChapterData(undefined));
                } else {
                  const sortedChapterList = selectedChapterList.sort(
                    (a, b) => a.chapterNo - b.chapterNo
                  );
                  setStep('chapterSelection');
                  dispatch(
                    setFASelectedChapterData({
                      ...chapter_topic_data,
                      chapters: sortedChapterList,
                    })
                  );
                }
                setOpenAddChapterPopup(false);
                await interactionEvent({
                  url: 'Teacher_formative-assessment-create',
                  context: 'Add_Chapter',
                  name: 'CONFIRM',
                  pathSegments: pathSegments,
                  isOffline: isOffline,
                });
              }}
            />
          }
        />
      }
      <EditWarningPopup
        open={editPopupOpen}
        handleClose={() => {
          if (logoClick) {
            setLogoClick(false);
            setSelectedLogoClickHandler(() => handleLogoClick);
          } else {
            setSelectedFunction(() => backButtonClick);
          }
          setEditPopupOpen(false);
        }}
        yesClickHandler={async () => {
          if (logoClick || home) {
            dispatch(resetAssessmentFlowState());
            navigate(HOME);
            return;
          }
          setStep(undefined);
          navigate(HOMEWORK_MANAGE);
          await interactionEvent({
            url: 'Teacher_formative_assessment_create',
            context: 'chapter_delete',
            name: 'YES',
            pathSegments: pathSegments,
            isOffline: isOffline,
          });
        }}
        noClickHandler={async () => {
          if (logoClick) {
            setLogoClick(false);
            setSelectedLogoClickHandler(() => handleLogoClick);
          } else {
            setSelectedFunction(() => backButtonClick);
          }
          setEditPopupOpen(false);
          await interactionEvent({
            url: 'Teacher_formative_assessment_create',
            context: 'chapter_delete',
            name: 'NO',
            pathSegments: pathSegments,
            isOffline: isOffline,
          });
        }}
        iconname="back"
        text1="If you go back, you may lose your changes."
        text2="Are you sure you want go back?"
      />
    </Box>
  );
};

interface IPopupBodyProps {
  confirmHandler: () => void;
  addHandler: (chapter: SubjectChapterMiniInfo) => void;
  deleteHandler?: (chapter: SubjectChapterMiniInfo) => void;
  chapterEditHandler: (chapter: SubjectChapterMiniInfo) => void;
  selectedChapterList: SubjectChapterMiniInfo[];
  onSelectAllChapters?: (chapters: SubjectChapterMiniInfo[]) => void;
}
export const ChapterListComponent = (props: IPopupBodyProps) => {
  const {
    confirmHandler,
    addHandler,
    deleteHandler,
    chapterEditHandler,
    selectedChapterList,
    onSelectAllChapters,
  } = props;
  const { fa_selected_chapter_data, chapter_topic_data } = deserify(
    useAppSelector((state) => state.assessment)
  );

  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const allChapters = chapter_topic_data?.chapters ?? [];
  const allChaptersSelected =
    allChapters.length > 0 &&
    allChapters.every((ch) =>
      selectedChapterList.some((s) => s.chapterId === ch.chapterId)
    );
  return (
    <>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          height: 'max-content',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography variant="h3" fontWeight="bold">
          Add Chapters
        </Typography>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: { xs: pxToRem(10), md: pxTovW(25) },
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: { xs: pxToRem(5), md: pxTovW(10) },
            }}
          >
            <Checkbox
              icon={<CheckBoxOutlineBlankIcon sx={{ color: '#007CDC' }} />}
              checkedIcon={<CheckBoxIcon sx={{ color: 'primary.main' }} />}
              checked={allChaptersSelected}
              onChange={(_, checked) => {
                onSelectAllChapters?.(checked ? [...allChapters] : []);
              }}
              sx={{
                '& .MuiSvgIcon-root': {
                  fontSize: { xs: pxToRem(20), md: pxTovW(24) },
                },
                padding: 0,
              }}
            />
            <Typography variant="h4" sx={{ fontFamily: 'Poppins' }}>
              Select All
            </Typography>
          </Box>
          <PrimaryButton
            onClick={confirmHandler}
            sx={{
              width: { xs: pxToRem(104), md: pxTovW(183), lg: pxTovW(153) },
              height: { xs: pxToRem(46), md: pxTovW(63), lg: pxTovW(53) },
            }}
          >
            <Typography
              variant={isMobile ? 'h4' : 'h5'}
              color="common.white"
              fontWeight="bold"
            >
              CONFIRM
            </Typography>
          </PrimaryButton>
        </Box>
      </Box>
      <Divider
        sx={{
          width: '100%',
          height: '1px solid #E0DFDE',
          marginY: { xs: pxToRem(10), md: pxTovW(20) },
        }}
      />
      <Box
        sx={{
          width: { xs: '100%', md: '100%' },
          display: 'flex',
          flexDirection: 'column',
          // justifyContent: 'center',
          alignItems: 'center',
          gap: pxTovW(20),
          height: '90%',
          overflowY: 'auto',
        }}
      >
        {chapter_topic_data?.chapters?.map((chapter, index) => (
          <Box key={index} sx={{ width: '100%' }}>
            <FAChapterSelectionCard
              selectedChapterList={selectedChapterList}
              selected={
                selectedChapterList
                  ? selectedChapterList.find(
                      (e) => e.chapterId === chapter.chapterId
                    ) !== undefined
                  : false
              }
              chapterInfo={chapter}
              variant="medium"
              addHandler={addHandler}
              deleteHandler={deleteHandler}
              chapterEditHandler={chapterEditHandler}
              allowCardClickDelete={true}
            />
          </Box>
        ))}
        {/* {chapter_topic_data?.chapters
          .filter(
            (c) =>
              !fa_selected_chapter_data?.chapters?.find(
                (ch) => ch.chapterId === c.chapterId
              )
          )
          .map((chapter, index) => (
            <Box key={index} sx={{ width: '100%' }}>
              <FAChapterSelectionCard
                selected={false}
                chapterInfo={chapter}
                variant="medium"
                addHandler={addHandler}
                deleteHandler={deleteHandler}
                chapterEditHandler={chapterEditHandler}
              />
            </Box>
          ))} */}
      </Box>
    </>
  );
};

const ChapterList = new CourseIndexInfo({
  subjectId: Number(1),
  subjectName: 'Science',
  posterImageUrl:
    'https://dev7-api.geneo.in/storage/stream/courses/subjects/Science/posterImageUrl',
  chapters: [
    {
      chapterId: 1,
      chapterNo: 1,
      chapterTitle: 'Crop Production and Management',
      posterImagesUrl:
        'https://dev7-api.geneo.in/storage/stream/courses/subjects/Science/chapters/1/posterImagesUrl',
      noOfTopics: 4,
      topics: [
        {
          topicId: 1,
          topicNo: 1,
          topicTitle: 'Topic 1',
          posterImagesUrl:
            'https://dev7-api.geneo.in/storage/stream/courses/subjects/Science/chapters/1/topics/1/posterImagesUrl',
        },
        {
          topicId: 2,
          topicNo: 2,
          topicTitle: 'Topic 2',
          posterImagesUrl:
            'https://dev7-api.geneo.in/storage/stream/courses/subjects/Science/chapters/1/topics/2/posterImagesUrl',
        },
        {
          topicId: 3,
          topicNo: 3,
          topicTitle: 'Topic 3',
          posterImagesUrl:
            'https://dev7-api.geneo.in/storage/stream/courses/subjects/Science/chapters/1/topics/3/posterImagesUrl',
        },
        {
          topicId: 4,
          topicNo: 4,
          topicTitle: 'Topic 4',
          posterImagesUrl:
            'https://dev7-api.geneo.in/storage/stream/courses/subjects/Science/chapters/1/topics/4/posterImagesUrl',
        },
      ],
    },
  ],
});
